import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "self-center cursor-pointer" };
const _hoisted_3 = { class: "self-center cursor-pointer" };
const _hoisted_4 = { class: "row justify-end" };
const _hoisted_5 = {
    key: 0,
    class: "self-center text-right pr-xs-lt-md detailed-btn"
};
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "self-center" };
const _hoisted_8 = { class: "self-center text-right hide-lt-md" };
const _hoisted_9 = { style: { "height": "80vh" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_app_multi_colored_icon = _resolveComponent("app-multi-colored-icon");
    const _component_router_link = _resolveComponent("router-link");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_q_item = _resolveComponent("q-item");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_list = _resolveComponent("q-list");
    const _component_q_menu = _resolveComponent("q-menu");
    const _component_header_cashback = _resolveComponent("header-cashback");
    const _component_search_browse_btn = _resolveComponent("search-browse-btn");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_verification_and_del_btn = _resolveComponent("verification-and-del-btn");
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_notifications = _resolveComponent("notifications");
    const _component_inbox = _resolveComponent("inbox");
    const _component_photo_toggle = _resolveComponent("photo-toggle");
    const _component_q_toolbar = _resolveComponent("q-toolbar");
    return (_openBlock(), _createBlock(_component_q_toolbar, { class: "row justify-between" }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_router_link, {
                        to: { name: 'Home' },
                        class: "self-center",
                        "aria-label": "Go Home"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_app_multi_colored_icon, {
                                    icon: (_ctx.$route.name?.toString() || '').toLowerCase().includes('propert') ? 'getproperty' : 'getspaces',
                                    "icon-size": 36
                                }, null, 8, ["icon"])
                            ])
                        ]),
                        _: 1
                    })
                ], 512), [
                    [_vShow, !_ctx.isOwner]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_app_multi_colored_icon, {
                            icon: (_ctx.$route.name?.toString() || '').toLowerCase().includes('propert') ? 'getproperty' : 'getspaces',
                            "icon-size": 36
                        }, null, 8, ["icon"])
                    ]),
                    _createVNode(_component_q_menu, {
                        modelValue: _ctx.quickNavMenu,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.quickNavMenu) = $event))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_list, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'Home' } }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_item, {
                                                clickable: "",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.quickNavMenu = false))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_item_section, {
                                                        side: "",
                                                        class: "pr-smd"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                                name: "home",
                                                                color: "positive",
                                                                size: "25px"
                                                            })
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_q_item_section, null, {
                                                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                            _createTextVNode(" Home ")
                                                        ])),
                                                        _: 1,
                                                        __: [11]
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_q_separator),
                                    _createVNode(_component_router_link, { to: { name: 'Admin Dashboard' } }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_item, {
                                                clickable: "",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.quickNavMenu = false))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_item_section, {
                                                        side: "",
                                                        class: "pr-smd"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                                name: "support_agent",
                                                                color: "primary",
                                                                size: "25px"
                                                            })
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_q_item_section, null, {
                                                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                            _createTextVNode(" Admin Panel ")
                                                        ])),
                                                        _: 1,
                                                        __: [12]
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ], 512), [
                    [_vShow, _ctx.isOwner]
                ]),
                _createVNode(_component_header_cashback, {
                    "home-header": _ctx.homeHeader,
                    class: "hide-lt-sm"
                }, null, 8, ["home-header"]),
                _withDirectives(_createVNode(_component_q_icon, {
                    name: "wifi_off",
                    size: "32px",
                    color: "grey-6",
                    class: "q-ml-md self-center"
                }, null, 512), [
                    [_vShow, !_ctx.isOnline]
                ])
            ]),
            _createElementVNode("div", _hoisted_4, [
                (!_ctx.user)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_search_browse_btn, {
                            "btn-class": {
                                'text-white': _ctx.homeHeader,
                                'grey8-grey1-text-color': !_ctx.homeHeader
                            }
                        }, null, 8, ["btn-class"])
                    ]))
                    : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_q_btn, {
                        flat: "",
                        type: "button",
                        label: "List with us",
                        "aria-label": "List With Us",
                        "data-cy": "list-with-us",
                        class: _normalizeClass(["text-weight-bold hide-lt-md", {
                                'text-white': _ctx.homeHeader,
                                'grey8-white-text-color': !_ctx.homeHeader
                            }]),
                        onClick: _ctx.goToListWithUs
                    }, null, 8, ["class", "onClick"])
                ], 512), [
                    [_vShow, !_ctx.user]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                    label: "Login",
                    "aria-label": "Login",
                    "data-cy": "login-btn",
                    class: "text-weight-bold",
                    color: "positive",
                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.requireLogin({ required: true }))),
                    id: "login-btn"
                }, null, 512), [
                    [_vShow, !_ctx.user]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                    flat: "",
                    label: "Sign up",
                    "aria-label": "Sign up",
                    class: _normalizeClass(["text-weight-bold detailed-btn", {
                            'hide-lt-md grey8-white-text-color': !_ctx.homeHeader,
                            'text-white': _ctx.homeHeader
                        }]),
                    onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.requireLogin({ required: true, tab: 'register' })))
                }, null, 8, ["class"]), [
                    [_vShow, !_ctx.user]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                    dense: "",
                    flat: "",
                    round: "",
                    class: "q-ml-sm consolidated-btn",
                    icon: "menu",
                    size: "14px"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_menu, { class: "hide-overflow st-wh-200" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_list, { separator: "" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_item, { clickable: "" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_item_section, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_search_browse_btn, {
                                                            "btn-class": {
                                                                'text-white': _ctx.homeHeader,
                                                                'grey8-grey1-text-color': !_ctx.homeHeader
                                                            },
                                                            "main-menu-offset": [240, -35]
                                                        }, {
                                                            button: _withCtx(() => [
                                                                _createElementVNode("div", _hoisted_6, [
                                                                    _createVNode(_component_q_icon, {
                                                                        class: "self-center q-pr-xs",
                                                                        name: "keyboard_arrow_left",
                                                                        size: "24px"
                                                                    }),
                                                                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('Browse Spaces')), 1)
                                                                ])
                                                            ]),
                                                            _: 1
                                                        }, 8, ["btn-class"])
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_q_item, {
                                            clickable: "",
                                            onClick: _ctx.goToListWithUs
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_item_section, null, {
                                                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                        _createTextVNode(" List with us ")
                                                    ])),
                                                    _: 1,
                                                    __: [13]
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_component_q_item, {
                                            clickable: "",
                                            onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.requireLogin({ required: true, tab: 'register' })))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_item_section, null, {
                                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                        _createTextVNode(" Sign up ")
                                                    ])),
                                                    _: 1,
                                                    __: [14]
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_q_item, {
                                            clickable: "",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.requireLogin({ required: true })))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_item_section, null, {
                                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                        _createTextVNode(" Login ")
                                                    ])),
                                                    _: 1,
                                                    __: [15]
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 512), [
                    [_vShow, !_ctx.user]
                ]),
                _createVNode(_component_verification_and_del_btn, {
                    "btn-class": {
                        'hide-lt-630 q-mr-sm': true
                    },
                    "btn-size": "14px"
                }),
                _withDirectives(_createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_search_browse_btn, {
                        "btn-class": {
                            'text-white': _ctx.homeHeader,
                            'grey8-grey1-text-color': !_ctx.homeHeader
                        }
                    }, null, 8, ["btn-class"])
                ], 512), [
                    [_vShow, _ctx.user]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                    flat: "",
                    round: "",
                    dense: "",
                    class: _normalizeClass(["q-mx-sm full-height self-center", {
                            'text-primary': _ctx.homeHeader && _ctx.showNotification,
                            'text-grey-2': _ctx.homeHeader && !_ctx.showNotification,
                            'grey8-white-text-color': !_ctx.homeHeader && !_ctx.showNotification
                        }]),
                    icon: "notification_important",
                    "aria-label": "Drawer",
                    "data-cy": "user-menu-drawer",
                    id: "navigation-toggle"
                }, {
                    default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_q_badge, {
                            color: "red",
                            "text-color": "white",
                            floating: ""
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.unreadNotifications > 9 ? '9+' : _ctx.unreadNotifications), 1)
                            ]),
                            _: 1
                        }, 512), [
                            [_vShow, _ctx.unreadNotifications > 0]
                        ]),
                        _createVNode(_component_q_menu, {
                            modelValue: _ctx.showNotification,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.showNotification) = $event)),
                            "max-height": "80vh",
                            "max-width": "450px",
                            target: "#navigation-toggle",
                            class: "hide-overflow"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_notifications, {
                                    menu: "",
                                    onClose: _cache[7] || (_cache[7] = ($event) => (_ctx.showNotification = false))
                                })
                            ]),
                            _: 1
                        }, 8, ["modelValue"])
                    ]),
                    _: 1
                }, 8, ["class"]), [
                    [_vShow, _ctx.user]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                    round: "",
                    dense: "",
                    flat: "",
                    class: _normalizeClass(["q-mx-sm full-height self-center", {
                            'text-primary': _ctx.homeHeader && _ctx.showInbox,
                            'text-grey-2': _ctx.homeHeader && !_ctx.showInbox,
                            'grey8-white-text-color': !_ctx.homeHeader && !_ctx.showInbox
                        }]),
                    icon: "message",
                    "aria-label": "Drawer",
                    "data-cy": "user-menu-drawer",
                    id: "user-menu-drawer"
                }, {
                    default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_q_badge, {
                            color: "red",
                            "text-color": "white",
                            floating: ""
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.unread > 9 ? '9+' : _ctx.unread), 1)
                            ]),
                            _: 1
                        }, 512), [
                            [_vShow, _ctx.unread > 0]
                        ]),
                        _createVNode(_component_q_menu, {
                            modelValue: _ctx.showInbox,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.showInbox) = $event)),
                            "max-height": "80vh",
                            "max-width": "450px",
                            offset: [50, 0],
                            target: "#user-menu-drawer",
                            class: "hide-overflow"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_inbox, {
                                        menu: "",
                                        onEnterChat: _cache[9] || (_cache[9] = ($event) => (_ctx.toggleDrawer('chat')))
                                    })
                                ])
                            ]),
                            _: 1
                        }, 8, ["modelValue"])
                    ]),
                    _: 1
                }, 8, ["class"]), [
                    [_vShow, _ctx.user]
                ]),
                (_ctx.user)
                    ? (_openBlock(), _createBlock(_component_photo_toggle, {
                        key: 1,
                        onClick: _ctx.toggleDrawer
                    }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
            ])
        ]),
        _: 1
    }));
}
